<template>
  <base-modal :customShowDialog="showQuerySettingsModal" :confirmEnabled="showConfirmBtn"
    :title="$t('modal.properties.title')" :confirmButton="$t('modal.properties.confirmBtn')"
    @confirmed="handleConfirmed" @close="handleClose">
    <div slot="body">
      <v-text-field class="filename-input" ref="queryNameInputField" v-model="localQueryName"
        :rules="[fileNameRules.checkMatch(exactMatch)]" :label="$t('modal.properties.fileNameLabel')"></v-text-field>
      <v-layout row>
        <v-flex md8>
          <v-select v-model="localDefaultSearchObject" :items="enabledEngines" item-text="name" return-object
            :label="$t('modal.properties.defaultSourceLabel')"></v-select>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex md3>
          <v-text-field v-model="localDefaultOperator"
            :label="$t('modal.properties.defaultOperatorLabel')"></v-text-field>
        </v-flex>
      </v-layout>
      <v-text-field v-model="localNotes" :label="$t('modal.properties.notesLabel')"></v-text-field>
    </div>
  </base-modal>
</template>

<script>
export default {
  name: 'properties-modal',
  components: {
    BaseModal: () => import('./BaseModal')
  },
  props: {
    customShowDialog: {
      type: Boolean,
      default: false
    },
    query: {
      type: Object,
      default: () => null
    },
    queries: {
      type: Array,
      default: () => []
    },
    confirmEnabled: {
      type: Boolean,
      default: false
    },
    enabledEngines: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localQueryName: '',
      localDefaultSearchObject: null,
      localDefaultOperator: '',
      localNotes: '',
      fileNameRules: {
        checkMatch(matchValue) {
          return _ => !matchValue || this.$t('modal.properties.warningFileWillBeOverwritten')
        }
      }
    }
  },
  computed: {
    showConfirmBtn() {
      const regex = new RegExp('[A-Za-z0-9]+')
      return this.localQueryName !== '' &&
        this.localQueryName !== null &&
        regex.test(this.localQueryName)
    },
    showQuerySettingsModal: {
      get() {
        return this.$store.state.modalState.showQuerySettingsModal
      }
    },
    matchingQueries() {
      if (!this.queries) return []
      if (!this.localQueryName) return this.queries

      const needle = this.localQueryName.toLowerCase()
      return this.queries.filter(q => {
        if (q.name) {
          const haystack = q.name.toLowerCase()
          return haystack.substring(0, needle.length) === needle
        }
        return false
      })
    },
    exactMatch() {
      return this.localQueryName &&
        this.matchingQueries.length >= 1 &&
        this.localQueryName === this.matchingQueries[0].name &&
        (!this.query || this.query._id !== this.matchingQueries[0]._id)
    }
  },
  watch: {
    showQuerySettingsModal(newVal) {
      if (newVal) {
        this.initializeValues()
      }
    }
  },
  methods: {
    initializeValues() {
      if (this.query) {
        // If editing existing query
        this.localQueryName = this.query.name || ''
        // Find the matching engine object based on the stored name
        this.localDefaultSearchObject = this.enabledEngines.find(
          engine => engine.name === this.query.defaultSearchName
        ) || (this.enabledEngines.length ? this.enabledEngines[0] : null)

        this.localDefaultOperator = this.query.defaultOperator || ''
        this.localNotes = this.query.notes || ''
      } else {
        // If creating new query
        this.localQueryName = ''
        this.localDefaultSearchObject = this.enabledEngines.length ? this.enabledEngines[0] : null
        this.localDefaultOperator = ''
        this.localNotes = ''
      }
    },
    handleConfirmed() {
      const updatedQuery = {
        newQueryName: this.localQueryName,
        newQueryDefaultSearchName: this.localDefaultSearchObject ? this.localDefaultSearchObject.name : this.enabledEngines[0].name,
        newQueryDefaultOperator: this.localDefaultOperator,
        newQueryNotes: this.localNotes
      }

      this.$emit('confirmed', updatedQuery)
    },
    handleClose() {
      this.$store.commit('setShowQuerySettingsModal', false)
    },
    resetForm() {
      this.initializeValues()
    }
  },
  created() {
    this.initializeValues()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/modals/PropertiesModal.vue